import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-traitementmasse',
  templateUrl: './traitementmasse.component.html',
  styleUrls: ['./traitementmasse.component.css']
})
export class TraitementmasseComponent implements OnInit {
  columnsDisplay = [
    {def: 'select', show: false},
    {def: 'user', show: true},
    {def: 'status', show: true},
    {def: 'start', show: true},
    {def: 'end', show: true},
    {def: 'Motif', show: true},
    {def: 'Comment', show: false}
  ];
  constructor(public router: Router, private http: HttpClient) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/view/traitementmasse/traitementmasse.component.ts